export default __webpack_public_path__ + "static/media/trading.998fbd99.png";